namespace Recommendations  {

    //These two functions are writen by TR/Christina (as opposed to made by DB4).
    //They can be deleted once the DB4 implementation is finished.

    type DestinationContentCard = Core.Destinations.DestinationContentCard;

    function HouseRecommender (
        $http: ng.IHttpService,
        broker: Core.Broker,
        imageService: any
    )
    {
        let cachedGet;

        broker.subscribe(
            'houseRecommender',
            'hotelSearchCreated',
            () => cachedGet = null
        );

        function getHouseRecs(): ng.IPromise<Core.Destinations.DestinationContentCard[]> {
            if (!cachedGet) {
                cachedGet = $http.get('website/recommendations/get', { ignoreErrors: true });
            }
            return cachedGet
                .then(_.partialRight(_.get, 'data'))
                .then(res => _enrichTrRecs(
                    _.get<RecommendedDestination[]>(res, 'Destinations'),
                    _.get<number>(res, 'Type')
                ));
        }

        function _enrichTrRecs(recs: RecommendedDestination[], type: number): DestinationContentCard[] {
            return _(recs)
                .map((r: RecommendedDestination) => {
                    // Map the API response to a DestinationContentCard view model
                    return <DestinationContentCard>{
                        Id: r.ObjectId,
                        Type: r.ObjectTypeId,
                        Title: r.Title,
                        ImageUrl: imageService.getDestinationImage({ Id: r.ObjectId, Type: r.ObjectTypeId }),
                        HolidayEnabled: r.HolidayEnabled,
                        HotelCount: r.HotelCount,
                        MinFlightPrice: r.MinFlightPrice,
                        MinHotelPrice: r.MinHotelPrice,
                        PagePath: r.PagePath,
                        Searchable: r.Searchable,
                        RecommendationType: type
                    };
                })
                .take(8)
                .value();
        }

        function trackHouseClick(d: DestinationContentCard) {
            const params = {
                type: d.RecommendationType,
                destinationId: d.Id,
                destinationType: d.Type
            };
            return $http.get(`website/recommendations/track?${$.param(params)}`, { ignoreErrors: true });
        }

        return {
            getHouseRecs,
            trackHouseClick
        };
    }

    angular
        .module('recommendations')
        .service('houseRecommender', HouseRecommender);
}
